import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
  Progress,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"

import { Button } from "@material-ui/core"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_friend.png"
import emptyLogin from "assets/images/ugifts/icons/empty/empty_login.png"
import referralActive from "assets/images/ugifts/icons/referral_active.png"
import referralInactive from "assets/images/ugifts/icons/referral_inactive.png"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const InviteFriends = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [shareCodeMessage, setShareCodeMessage] = useState(
    props.t("Share your code")
  )
  const [currency, setCurrency] = useState("")
  const [isGuest, setIsGuest] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    } else {
      setIsGuest(true)
    }

    if (localStorage.getItem("currency")) {
      setCurrency(localStorage.getItem("currency"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      if (!isGuest) {
        getUserProfile()
        getCampaign()
      }
      console.log("use effect")
    }
  }, [token])

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [campaignData, setCampaignData] = useState(null)
  const getCampaign = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_campaign")
    if (!isGuest) urlencoded.append("member_id", uid)
    urlencoded.append("campaign_id", 25)

    // urlencoded.append("member_id", 58)
    // urlencoded.append("campaign_id", 8)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request get campaign", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setCampaignData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const handleCopy = input => {
    const textField = document.createElement("textarea")
    textField.innerText = input
    document.body.appendChild(textField)
    textField.select()
    document.execCommand("copy")
    textField.remove()
    setShareCodeMessage("Copied")
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  backgroundColor: isGuest ? "#FFFFFF" : "#F5F5F5",
                  // paddingBottom: "130px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {props.t("Invite a friend")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    {!isGuest ? (
                      <Row className="px-3 mt-5 mb-0">
                        <Col>
                          <span className="font-size-20">
                            🎉Invite your friends to Ugift
                          </span>
                          {campaignData && (
                            <span
                              className="font-size-16"
                              dangerouslySetInnerHTML={{
                                __html: campaignData.description,
                              }}
                            ></span>
                          )}
                        </Col>
                      </Row>
                    ) : (
                      <UgiftEmptyState
                        image={emptyLogin}
                        title={props.t("Welcome, please login to continue")}
                        link={"/login"}
                        linkText={props.t("Login Now")}
                      />
                    )}
                    {/* <Row className="px-3 mt-1">
                      <Col>
                        <span className="font-size-14">
                          {"Earn " +
                            currency +
                            " 5 Ugift credits when your friend signs up using your referral code and spends " +
                            currency +
                            " 10"}
                        </span>
                      </Col>
                    </Row>
                    <Row className="px-3 mt-3">
                      <Col className="align-self-center">
                        <i
                          className="bx bx-info-circle align-middle font-size-20 text-primary me-2"
                          style={{ fontWeight: 700 }}
                        />
                        <span
                          className="font-size-14 text-primary align-middle"
                          style={{ fontWeight: 700 }}
                        >
                          {"How it works"}
                        </span>
                      </Col>
                    </Row>
                    <Row className="px-3 mt-4">
                      <Col className="align-self-center" xs="auto">
                        <div className="avatar-sm">
                          <span
                            className={
                              "avatar-title rounded-circle bg-white text-primary font-size-24"
                            }
                          >
                            {"1"}
                          </span>
                        </div>
                      </Col>
                      <Col>
                        <Row>
                          <Col>
                            <span
                              className="font-size-16 align-middle"
                              style={{ fontWeight: 700 }}
                            >
                              {"Invite Your Friends"}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <span className="font-size-14 align-middle">
                              {
                                "Connect your Ugift account to Facebook or share your referral code"
                              }
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="px-3 mt-4">
                      <Col className="align-self-center" xs="auto">
                        <div className="avatar-sm">
                          <span
                            className={
                              "avatar-title rounded-circle bg-white text-primary font-size-24"
                            }
                          >
                            {"2"}
                          </span>
                        </div>
                      </Col>
                      <Col>
                        <Row>
                          <Col>
                            <span
                              className="font-size-16 align-middle"
                              style={{ fontWeight: 700 }}
                            >
                              {"Your friend signs up for a Ugift account"}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <span className="font-size-14 align-middle">
                              {"Upon signing up, they spend " +
                                currency +
                                " 10 and the referral will be confirmed"}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="px-3 mt-4">
                      <Col className="align-self-center" xs="auto">
                        <div className="avatar-sm">
                          <span
                            className={
                              "avatar-title rounded-circle bg-white text-primary font-size-24"
                            }
                          >
                            {"3"}
                          </span>
                        </div>
                      </Col>
                      <Col>
                        <Row>
                          <Col>
                            <span
                              className="font-size-16 align-middle"
                              style={{ fontWeight: 700 }}
                            >
                              {"Both you and your friend earns!"}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <span className="font-size-14 align-middle">
                              {currency +
                                " 5 will be credited into both you and your friend's Ugift account"}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row> */}
                    {
                      !isGuest &&
                        campaignData &&
                        campaignData.child_campaign.length > 0 &&
                        campaignData.child_campaign.map((object, index) =>
                          object.campaign_progress.percentage >= 100 ? (
                            <Row key={"child-campaign-" + index}>
                              <Col xs="auto">
                                <img
                                  src={referralActive}
                                  className="avatar-sm"
                                  alt=""
                                  style={
                                    {
                                      // maxWidth: "24px",
                                      // maxHeight: "24px",
                                    }
                                  }
                                />
                              </Col>
                              <Col>
                                <Card
                                  className="p-3 shadow-none mb-3"
                                  style={{
                                    borderRadius: "0px",
                                    // width: "160px",
                                    // height: "196px",
                                    backgroundColor: "white",
                                  }}
                                >
                                  <Row className="mb-2">
                                    <Col>
                                      <span className="font-size-15 text-primary">
                                        <strong>
                                          {object.campaign_progress.percentage +
                                            "%"}
                                        </strong>
                                      </span>
                                    </Col>
                                    <Col xs="auto">
                                      <span className="font-size-15 text-secondary">
                                        {
                                          object.campaign_progress
                                            .campaign_progress_message
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <Progress
                                        color="primary"
                                        value={
                                          object.campaign_progress.percentage
                                        }
                                      />
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            </Row>
                          ) : (
                            <Row key={"child-campaign-" + index}>
                              <Col>
                                <Card
                                  className="p-3 shadow-none mb-3"
                                  style={{
                                    borderRadius: "0px",
                                    // width: "160px",
                                    // height: "196px",
                                    backgroundColor: "white",
                                  }}
                                >
                                  <Row>
                                    <Col xs="auto" className="pe-0">
                                      <img
                                        src={referralInactive}
                                        className="avatar-sm"
                                        alt=""
                                        style={
                                          {
                                            // maxWidth: "24px",
                                            // maxHeight: "24px",
                                          }
                                        }
                                      />
                                    </Col>
                                    <Col>
                                      <Row className="mb-2">
                                        <Col>
                                          <span className="font-size-15 text-primary">
                                            <strong>{object.name}</strong>
                                          </span>
                                        </Col>
                                        <Col xs="auto">
                                          <span className="font-size-15 text-secondary">
                                            {
                                              object.campaign_progress
                                                .campaign_progress_message
                                            }
                                          </span>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col>
                                          <Progress
                                            color="primary"
                                            value={
                                              object.campaign_progress
                                                .percentage
                                            }
                                          />
                                        </Col>
                                      </Row>
                                      <Row className="mt-2">
                                        <Col>
                                          <span className="font-size-15 text-primary">
                                            <strong>{}</strong>
                                          </span>
                                        </Col>
                                        <Col xs="auto">
                                          <span className="font-size-15 text-secondary">
                                            {props.t("5,000 points")}
                                          </span>
                                        </Col>
                                      </Row>
                                      {object.is_redeemed && (
                                        <Row className="mt-2">
                                          <Col>
                                            <span className="font-size-15 text-primary">
                                              <strong>{}</strong>
                                            </span>
                                          </Col>
                                          <Col xs="auto">
                                            <span className="font-size-15 text-secondary">
                                              {props.t("Claimed : ") +
                                                object.is_redeemed_date}
                                            </span>
                                          </Col>
                                        </Row>
                                      )}
                                    </Col>
                                  </Row>
                                </Card>
                              </Col>
                            </Row>
                          )
                        )
                      // <Row className="px-3 mt-4">
                      //   <Col>
                      //     <span className="font-size-14">
                      //       {
                      //         "Rewards feature currently unavailable and will be available in the near future."
                      //       }
                      //     </span>
                      //   </Col>
                      // </Row>
                    }
                    {!isGuest && (
                      <Row className="px-3 mt-5">
                        <Col>
                          <Card
                            className="p-3 mx-auto shadow-none"
                            style={{
                              maxWidth: "180px",
                              borderRadius: "16px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              userData &&
                                handleCopy(
                                  userData.name +
                                    " invited you to join Ugift, click the link to register https://sg.ugiftglobal.com/UgiftWeb/invitation?referral=" +
                                    userData.referral_code
                                )
                            }}
                          >
                            <Row>
                              <Col xs="auto" className="mx-auto">
                                <span
                                  className="font-size-12 text-primary align-middle text-center"
                                  style={{ fontWeight: 700 }}
                                >
                                  {shareCodeMessage}
                                </span>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs="auto" className="mx-auto">
                                <span
                                  className="font-size-20 text-dark align-middle text-center me-2"
                                  style={{ fontWeight: 700 }}
                                >
                                  {userData && userData.referral_code}
                                </span>
                                <i className="bx bxs-copy align-middle font-size-20 text-dark" />
                              </Col>
                            </Row>
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {/* <Row
                      className="m-0 w-100"
                      style={{
                        height: "130px",
                        backgroundColor: "#ffffff",
                        position: "fixed",
                        bottom: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                        boxShadow: "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                      }}
                    >
                      <Col className="h-100 p-0">
                        <Row className="mt-3">
                          <Col xs="auto" className="align-self-center mx-auto">
                            <span className="align-middle font-size-15 h-100">
                              {"Invite your friends to join Ugift"}
                            </span>
                          </Col>
                        </Row>
                        <Card body className="mb-0 p-3">
                          <Link
                            to="#"
                            className="btn btn-danger waves-effect waves-light font-size-18"
                            // style={{ height: "42px" }}
                          >
                            {"Invite Friends"}
                          </Link>
                        </Card>
                      </Col>
                    </Row> */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(InviteFriends)

InviteFriends.propTypes = {
  t: PropTypes.any,
}
